<template>
    <ul class="cash-list">
        <li class="content" v-for="(item,index) in sort" :key="index">
            <div class="left">
                <p>{{item.type | getTitle}}</p>
                <!-- <span>收益</span> -->
            </div>
            <div class="right">
                <p>{{item.time | getStrTime}}</p>
                <b :class="{green:((item.amount-0)<0)}">{{getStrNum(item)}}</b>
            </div>
        </li>
        <li class="content bottom">
            已全部加载
        </li>
    </ul>
</template>

<script>
export default {
  name: 'cash-list',
  props:['list','type'],
  computed:{
      sort(){
          return this.list.sort((a,b)=>b.time-a.time);
      }
  },
  filters : {
      getTitle (type) {
          const map =  new Map([
            [ 0, '活动收益' ],
            [ 1, '游戏红包' ],
            [ 2, '新手任务' ],
            [ 3, '签到' ],
            [ 4, '每日任务' ],
            [ 5, '金币转化' ],
            [ 6, '游戏红包' ],
            [ 7, '提现' ],
            [ 8, '倒计时红包' ],
            [ 9, '排行榜收益' ],
            [ 10, '目标收益' ],
            [ 11, '新人红包' ],
            [ 12, '加成奖励' ],
            [ 13, '幸运红包' ],
            [ 14, '新人见面礼' ],
            [ 15, '收徒收益' ],
            [ 16, '唤醒收益' ],
            [ 17, '进贡收益' ],
            [ 18, '任务加成10%' ],
            [ 19, '补偿奖励' ],
            [ 20, '试玩收益' ],
            [ 21, '奖券瓜分奖励' ],
            [ 22, '刮刮乐奖励' ],
            [ 23, '刮刮乐额外奖金' ],
            [ 24, '口令奖励' ],
            [ 25, '邮件奖励' ],
            [ 26, '分享奖励' ],
            [ 27, '分享成功奖励' ],
            [ 28, '竞猜收益' ],
            [ 29, '试玩收益' ],
            [ 30, '游戏红包(翻倍)' ],
            [ 31, '充值返现' ],
            [ 32, '活动金币兑换' ],
            [ 33, '随机宝箱收益' ],
            [ 34, '悬赏任务收益' ],
            [ 35, '邀请挑战赛' ],
            [ 36, '玩游戏' ],
            [ 37, '日常广告任务收益' ],
            [ 38, '试玩收益' ],
            [ 39, '道具收益' ],
            [ 40, '比赛奖励' ],
            [ 41, '刮刮卡奖励' ],
            [ 42, '闲玩排行榜奖励' ],
            [ 43, '临时活动奖励' ],
            [ 44, '官方补偿' ],
            [ 45, '打卡报名' ],
            [ 46, '打卡奖励' ],
            [ 47, '打卡翻倍奖励' ],
            [ 48, '扩品类竞赛' ],
            [ 49, '分金库' ],
            [ 50, '新手摇数字' ],
            [ 51, '离线金币' ],
            [ 52, '离线金币' ],
            [ 53, '睡觉赚钱' ],
            [ 60, '走路赚钱' ],
            [ 61, '走路赚钱' ],
            [ 62, '推广奖励' ],
            [ 63, '兑换道具' ],
            [ 64, '游戏收益' ]
        ]);
          return map.get(type) || '活动收益';
      },
      getStrTime (time) {
          let date=new Date(time);
          return (date.getMonth()-1+2)+'-'+(date.getDate()>9?date.getDate():'0'+date.getDate())+' '+(date.getHours()>9?date.getHours():'0'+date.getHours())+':'+(date.getMinutes()>9?date.getMinutes():'0'+date.getMinutes());
      }
  },
  mounted() {
      console.log(this.list);
      console.log(this.type);
  },
  methods:{
      getStrNum(item){
          let num=item.amount;
          if(this.type=='cash' || this.type=='deposit'){
              return num>0?'+'+(Number(num)/100).toFixed(2):num==0?'+0.00':(Number(num)/100).toFixed(2);
          }else{
              return num>0?'+'+Number(num).toFixed(0):num==0?'+0':Number(num).toFixed(0);
          }
      }
  }
}
</script>

<style lang="less" scoped>
    .content{
        position: relative;
        height: 62px;
        border-bottom: 1px solid #eaeaea;
        font-size: 14px;
    }
    .left{
        text-align: left;
        padding: 12px 90px 0 12px;
    }
    .left>p{
        color: #333333;
        font-size: 16px;
        margin-top: 8px;
    }
    span,p,b{
        color: #919191;
        line-height: 24px;
        white-space:nowrap;
        overflow: hidden;
        text-overflow:ellipsis;
    }
    .right p{
        font-size: 12px;
    }
    b{
        color: #f00;
        font-size: 16px;
        font-weight: normal;
    }
    .green{
        color: #0f0;
    }
    .right{
        padding: 12px ;
        text-align: right;
        position: absolute;
        right: 0;
        top: 0;
    }
    .bottom.content{
        font-size: 16px;
        color: #333;
        line-height: 70px;
        text-align: center;
    }

</style>
